'use strict';

var GridToolbarDataExtractCompletedController = function GridToolbarDataExtractCompletedController($scope) {
  $scope.isDeleteButtonShown = false;
  $scope.selectedRows = null;
  $scope.onRowSelection = function (selectedRows) {
    $scope.selectedRows = selectedRows;
    $scope.isDeleteButtonShown = selectedRows.length > 0;
    $scope.selectedRow = selectedRows.length === 1 ? selectedRows[0] : null;
  };
  $scope.createNew = function () {
    $scope.$emit('data-extract:activatePanel', 'new-extract');
  };
  $scope.deleteSelected = function () {
    $scope.$emit('data-extract:deleteSelectedCompleted', $scope.selectedRows);
  };
};
GridToolbarDataExtractCompletedController.$inject = ['$scope'];
module.exports = GridToolbarDataExtractCompletedController;